<div class="px-3 pt-2r">
  <h1 class="mb-3">{{ 'COMPANY_ACCOUNT.TITLE' | translate }}</h1>
  <div class="bg-white shadow-sm mb-5">
    <ul class="nav nav-pills d-flex gap-4 px-4 border-bottom">
      @if (hasPermissionToViewPurchaseAndSalesAgreement) {
        <li class="nav-item cursor-pointer" data-testid="agreementTab">
          <span
            class="nav-link full-bottom-border-width px-0"
            [class.active]="agreementTabActive"
            (click)="activeTab = 'agreement'"
          >
            {{ 'COMPANY_ACCOUNT.PURCHASE_AND_SALES_AGREEMENT' | translate }}
          </span>
        </li>
      }
      @if (hasPermissionToViewCompanyInformation) {
        <li class="nav-item cursor-pointer" data-testid="informationTab">
          <span
            class="nav-link full-bottom-border-width px-0"
            [class.active]="!agreementTabActive"
            (click)="activeTab = 'information'"
          >
            {{ 'COMPANY_ACCOUNT.COMPANY_INFORMATION' | translate }}
          </span>
        </li>
      }
    </ul>

    @if (company) {
      <div class="p-4">
        @if (agreementTabActive) {
          <h2 class="color-black m-0 fw-bold">{{ 'COMPANY_ACCOUNT.REVIEW_AGREEMENT_INFORMATION' | translate }}</h2>

          <div class="d-flex mt-3">
            <div class="w-50">
              <div class="rounded-4 bg-primary-100 px-4 py-3">
                <h3 class="mb-0 py-1">{{ 'COMPANY_ACCOUNT.SALES_TARGET' | translate }}</h3>
                <p class="color-gray-900 py-1 m-0">{{ 'COMPANY_ACCOUNT.YOUR_SALES_TARGET' | translate: { year: company.salesTarget?.year ?? '-' } }} {{
                  (company.salesTarget?.amount ?? 0) | priceListCurrency : 'symbol' : '1.0' : currencyName }}</p>
              </div>

              <div class="px-4">
                <h3 class="pt-2r pb-3 m-0">{{ 'COMPANY_ACCOUNT.COOPERATION_TERMS' | translate }}</h3>
                <div class="border-top d-flex gap-3 align-items-center pt-1-25r pb-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.TYPE_OF_PRICELIST' | translate }}:</span>
                  <span class="w-50 color-gray-900">{{ company.priceList?.d365Name ?? '-' }}</span>
                </div>
                <div class="d-flex gap-3 align-items-center mt-2 py-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.MINIMUM_DISPATCH_SERVICE' | translate }}:</span>
                  <span class="w-50 color-gray-900">{{ (company.minimumDispatch?.fee ?? 0) | priceListCurrency : 'symbol' : '1.0' : currencyName }}</span>
                </div>
                <div class="d-flex gap-3 align-items-center mt-2 py-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.MINIMUM_DISPATCH_FEE' | translate }}:</span>
                  <span class="w-50 color-gray-900">{{ (company.minimumDispatch?.service ?? 0) | priceListCurrency : 'symbol' : '1.0' : currencyName }}</span>
                </div>
                <div class="d-flex gap-3 align-items-center mt-2 py-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.FIXED_DISCOUNT_RATE' | translate }}:</span>
                  <div class="w-50">
                    @if (company.discount) {
                      <h4 class="d-inline-block rounded-4 px-2 py-1 bg-primary-600 border-0 color-white m-0">{{ company.discount }}%</h4>
                    } @else {
                      <span class="color-gray-900">0%</span>
                    }
                  </div>
                </div>
              </div>

              <div class="px-4">
                <h3 class="pt-2r pb-3 m-0">{{ 'COMPANY_ACCOUNT.PAYMENT_TERMS' | translate }}</h3>
                <div class="border-top d-flex gap-3 align-items-center pt-1-25r pb-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.CURRENCY' | translate }}:</span>
                  <span class="w-50 color-gray-900">{{ company.currency?.name ?? '-' }}</span>
                </div>
                <div class="d-flex gap-3 align-items-center mt-2 py-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.PAYMENT_SCHEDULE' | translate }}:</span>
                  <div class="w-50 d-flex align-items-center">
                    <span class="color-gray-900">{{ company.paymentSchedule ?? '-' }}</span>
                    @if (company.paymentSchedule) {
                      <i
                        class="icon ni-info color-gray-500 ms-2"
                        tooltipOpener
                        [tooltipContent]="getPaymentScheduleTooltipContent() | translate"
                        tooltipPosition="bottom"
                        tooltipArrowPosition="top"
                      ></i>
                    }
                  </div>
                </div>
                <div class="d-flex gap-3 align-items-center mt-2 py-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.CREDIT_LIMIT' | translate }}:</span>
                  <span class="w-50 color-gray-900">{{ (company.creditLimit ?? 0) | priceListCurrency : 'symbol' : '1.0' : currencyName }}</span>
                </div>
              </div>
            </div>
            <div class="w-50">
              <div class="px-4">
                <h3 class="pt-2 pb-3 m-0">{{ 'COMPANY_ACCOUNT.DELIVERY_TERMS' | translate }}</h3>
                <div class="border-top d-flex gap-3 align-items-center pt-1-25r pb-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.TYPE_OF_DELIVERY' | translate }}:</span>
                  <span class="w-50 color-gray-900">{{ company.delivery?.type ?? '-' }}</span>
                </div>
                <div class="d-flex gap-3 align-items-center mt-2 py-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.MAIN_DELIVERY_ADDRESS' | translate }}:</span>
                  <span class="w-50 color-gray-900">{{ company.delivery?.address ?? '-' }}</span>
                </div>
                <div class="d-flex gap-3 align-items-center mt-2 py-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.METHOD_OF_LOADING_AND_DELIVERY' | translate }}:</span>
                  <div class="w-50 d-flex align-items-center">
                  <span class="color-gray-900">{{ company.delivery?.method ?? '-' }}</span>
                  @if (company.delivery?.method) {
                    <i
                      class="icon ni-info color-gray-500 ms-2"
                      tooltipOpener
                      [tooltipContent]="getMethodOfDeliveryTooltipContent() | translate"
                      tooltipPosition="bottom"
                      tooltipArrowPosition="top"
                    ></i>
                  }
                  </div>
                </div>
              </div>

              <div class="px-4">
                <h3 class="pt-2r pb-3 m-0">{{ 'COMPANY_ACCOUNT.AGREEMENT' | translate }}</h3>
                <div class="border-top d-flex gap-3 align-items-center pt-1-25r pb-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.AGREEMENT_EFFECTIVE_UNTIL' | translate }}:</span>
                  <span class="w-50 color-gray-900">{{ company.agreement?.expiration ?? '-' }}</span>
                </div>
                <div class="d-flex gap-3 align-items-center mt-2 py-1">
                  <span class="w-50">{{ 'COMPANY_ACCOUNT.AGREEMENT_ID' | translate }}:</span>
                  <span class="w-50 color-gray-900">{{ company.agreement?.id ?? '-' }}</span>
                </div>
                <div class="mt-2 px-075r py-2 border border-1 rounded-4">
                  <div class="fw-bold small lh-sm">{{ 'COMPANY_ACCOUNT.AMENDMENTS' | translate }}</div>
                  <div class="mt-2 small lh-sm">{{ company.agreement?.amendments ?? '-' }}</div>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <app-company-information [company]="company" />
        }
      </div>
    }
  </div>
</div>
